export const environment = {
  production: true,
  IDENTITY_POOL_ID: '',
  REGION: 'ap-southeast-1',
  CLIENT_ID: '4m23n3qii61i488el7r013s7du',
  AUTHORIZER_ENDPOINT: 'https://auth.cynopsis.co/cynopsis-production-2',
  ENFORCE_2FA: false,
  POOL_ID: 'ap-southeast-1_DQPYmWYnV',
  API_BASE: 'https://a2-netssingapore-prod-be.cynopsis.co',
  API_BASE_XERO: 'https://xerointegration-722576701.ap-southeast-1.elb.amazonaws.com',
  HANDSHAKES_BASE: 'https://app.handshakes.com.sg',
  ALLOW_DELETE_CUSTOMER: true,
  ALLOW_DELETE_COMMENT: true,
  ENABLE_HANDSHAKES: true,
  ENABLE_OPENCORPORATES: true,
  ENABLE_ARES_INTEGRATION: false,
  ENABLE_SCREENING_RESULT_COMMENT: true,
  ENABLE_SENTRY: true,
  SENTRY_DSN: 'https://7a6ac1a574d948b585d030578c7c6d25@sentry.cynopsis.co/4',
  PUSHER: {
    KEY: '052468eaacade031a906',
    CLUSTER: 'ap1'
  },
  SESSION_TIMEOUT: 86400000,
  VERSION: '2.33.0'
};
